import { createModalContext } from "shared/components/vero-modal";

import { UpdateIncomeProps } from "../../types";

export const {
  Context: EditIncomeModalContext,
  Provider: EditIncomeModalProvider,
  useModalContext: useEditIncomeModal,
} = createModalContext<UpdateIncomeProps>();
